// @owners { team: patients-team }
import autobind from 'autobind-decorator';
import React from 'react';
import { push } from 'react-router-redux';
// eslint-disable-next-line import/no-deprecated
import { updateOnboardingUser } from '~shared/actions/onboarding';
import {
  ONBOARD_STATE_TARGETED_DIAGNOSES,
  TARGETED_DIAGNOSES,
} from '~shared/features/onboarding/helpers/onboardingRouteHandler';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import OnboardingTargetedDiagnoses, {
  type Props as OnboardingTargetedDiagnosesProps,
} from './OnboardingTargetedDiagnoses';
import { nextUrl } from '~web/features/onboarding/helpers/urlHandler';

type Props = OnboardingTargetedDiagnosesProps & {
  // eslint-disable-next-line import/no-deprecated
  readonly updateOnboardingUser: typeof updateOnboardingUser;
  readonly nextUrl: string;
  readonly push: (url: string) => void;
};

class OnboardingTargetedDiagnosesContainer extends React.PureComponent<Props> {
  componentDidMount() {
    this.props.updateOnboardingUser({
      onboard_state: ONBOARD_STATE_TARGETED_DIAGNOSES,
    });
  }

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  onContinue() {
    this.props.push(this.props.nextUrl);
  }

  render() {
    return (
      <OnboardingTargetedDiagnoses
        {...this.props}
        // eslint-disable-next-line @typescript-eslint/unbound-method
        onContinue={this.onContinue}
      />
    );
  }
}

const mapStateToProps = (state: ReduxStateShared) => {
  return {
    nextUrl: nextUrl(state, TARGETED_DIAGNOSES),
  };
};

const mapDispatchToProps = {
  // eslint-disable-next-line import/no-deprecated
  updateOnboardingUser,
  push,
};

// @ts-expect-error TS(2345): Argument of type 'typeof OnboardingTargetedDiagnosesContainer' is not assignable to parameter of type ... (Delete me to see the full error)
export default connect(mapStateToProps, mapDispatchToProps)(OnboardingTargetedDiagnosesContainer);
